import store from '../store'
import { GROUPS_ADMIN_SET_GROUPS } from '../reducers/groups-admin'
const apiUrl = window.APP_CONFIG.REACT_APP_API_URL

/**
 * Load groups organizing tree
 *
 * @returns {Promise<unknown>}
 */
export const loadOrganizingTree = () => (
    window.axios.get(`${apiUrl}api/groups/organizing-tree?include=systemVisibility`)
        .then(({ data }) => {
            store.dispatch({
                type: GROUPS_ADMIN_SET_GROUPS,
                groups: data,
            })

            return new Promise(resolve => resolve(data))
        })
)

/**
 * Delete group
 *
 * @param {string} slug
 * @returns {AxiosPromise}
 */
export const deleteGroup = slug => (
    window.axios.delete(`${apiUrl}api/groups/${slug}`)
)

/**
 * Set group parent
 *
 * @param {string} slug
 * @param {string} parentId
 * @param {number|null} order - ordering in tree
 * @returns {AxiosPromise<any>}
 */
export const setGroupParent = (slug, parentId, order = 0) => (
    window.axios
        .put(`${apiUrl}api/groups/${slug}/parent`, {
            parent_id: !parentId || parentId === '' ? null : parentId,
            order: order,
        })
)
